import { FC } from 'react'

import { getLocationTitle } from 'entities/kyrgyzstan'
import {
  type RealtySelectionItem,
  RealtySelectionSection,
} from 'entities/kyrgyzstan/ui'

import type { RealtyObject } from 'shared/api/kyrgyzstan/search'
import { ContactToWhatsapp } from 'shared/ui/contact-to-whatsapp'

import { shouldShowPoliciesSection } from './lib/realty-details-section-config'
import s from './styles.module.scss'
import {
  CheckinSection,
  DescriptionSection,
  HeadSection,
  ImageSection,
  MapSection,
  PoliciesSection,
  type StaySummaryParams,
  StaySummarySection,
  VoucherSection,
} from './ui'

interface KyrgyzstanDetailContentProps {
  realty: RealtyObject
  childrenList?: RealtySelectionItem[]
  isChildrenListLoading?: boolean
  isShowVoucher?: boolean
  stayParams?: StaySummaryParams | null
  childrenTitle?: string
  onOpenVoucher?: () => void
  onOpenDates?: () => void
  onOpenGuests?: () => void
  onOpenGallery: (realtyId: string) => void
  onOpenMap: (realtyId: string) => void
  onSelectOption?: (optionId: string) => void
}

export const KyrgyzstanDetailContent: FC<KyrgyzstanDetailContentProps> = ({
  realty,
  childrenList = [],
  isChildrenListLoading = false,
  isShowVoucher = false,
  stayParams,
  childrenTitle,
  onOpenVoucher,
  onOpenDates,
  onOpenGuests,
  onOpenGallery,
  onOpenMap,
  onSelectOption,
}) => {
  const hasChildren = Boolean(childrenList.length)

  return (
    <div className={s.container}>
      <div>
        <ImageSection
          images={realty.images}
          onOpenGallery={() => onOpenGallery(realty.id)}
        />

        <HeadSection
          title={realty.title}
          location={getLocationTitle(
            realty.city,
            realty.address,
            realty.source,
          )}
          popularDynamicFields={realty.popular_dynamic_fields}
          dynamicFields={realty.dynamic_fields}
          realtyId={realty.id}
        />
      </div>

      {isShowVoucher && <VoucherSection onOpenVoucher={onOpenVoucher} />}

      <DescriptionSection description={realty.description} />

      <CheckinSection
        checkin={realty.times?.arrival_time}
        checkout={realty.times?.departure_time}
        timezone={realty.timezone}
      />

      <StaySummarySection
        stayParams={stayParams}
        onOpenDates={onOpenDates}
        onOpenGuests={onOpenGuests}
      />

      {(hasChildren || isChildrenListLoading) && (
        <RealtySelectionSection
          title={childrenTitle}
          items={childrenList}
          isLoading={isChildrenListLoading}
          onSelectOption={onSelectOption}
        />
      )}

      {/* <OwnerSection owner={realty.owner} /> */}

      <MapSection
        title={realty.title}
        latitude={realty.latitude}
        longitude={realty.longitude}
        onOpenFullMap={() => onOpenMap(realty.id)}
      />

      {shouldShowPoliciesSection(realty.source) && <PoliciesSection />}

      <ContactToWhatsapp />
    </div>
  )
}
